export default __webpack_public_path__ + "static/media/visaLogo.11ad2d88.svg";